import { all, fork } from "redux-saga/effects";

//public
import LoginSaga from "./Login/saga";
import ServiceSaga from "./Service/saga";
import agencySaga from "./agency/saga";
import driverSaga from "./drivers/saga";
import disputeSaga from "./dispute/saga";
import SettingsSaga from "./Settings/saga";
import FaqSaga from "./Faq/saga";
import ContentpageSaga from "./Content/saga";
import VendorSaga from "./Vendor/saga";

export default function* rootSaga() {
  yield all([fork(LoginSaga)]);
  yield all([fork(ServiceSaga)]);
  yield all([fork(agencySaga)]);
  yield all([fork(driverSaga)]);
  yield all([fork(disputeSaga)]);
  yield all([fork(SettingsSaga)]);
  yield all([fork(FaqSaga)]);
  yield all([fork(ContentpageSaga)]);
  yield all([fork(VendorSaga)]);
}
